<template>
  <div class="home">
    <ImageSlider
      :items="headerImages"
      :boxHeight="'70vh'"
      :animateTitle="false"
    />
  </div>
</template>

<script>
import ImageSlider from "@/components/ImageSlider.vue";
import { mapState } from "vuex";
import Localization from "@/mixins/LocalizationMixin.js";

export default {
  name: "HomeView",
  components: {
    ImageSlider,
  },
  mixins: [Localization],
  computed: {
    ...mapState(["cmsUrl", "headerimg"]),
    headerImages() {
      if (
        !this.headerimg ||
        !this.headerimg.attributes ||
        !this.headerimg.attributes.MBH_BiografieSlider
      ) {
        return []; // Rückgabe eines leeren Arrays, falls die Daten noch nicht vorhanden sind
      }

      let header = this.headerimg.attributes.MBH_homeSlider;
      let output = [];
      let ti = "Michael Bully Herbig";
      let cms = this.cmsUrl;

      header.forEach((h) => {
        output.push({
          id: h.id,
          title: ti,
          image: cms + h.image.data.attributes.url,
        });
      });
      return output;
    },
  },
};
</script>
